export const positionalRegex = {
    whole: /!!((\w)|(\s)|(%))*!!\?\?((\w)|(\s))*\?\?/,
    stat: /!!((\w)|(\s)|(%))*!!/,
    position: /\?\?((\w)|(\s))*\?\?/
}